export const baseURL = window.location.origin;
export const wsURL = `${window.location.origin.replace('http', 'ws')}/api/ws`
export const initAlways = false;
